import { render, staticRenderFns } from "./backToTop.vue?vue&type=template&id=aede5abe&scoped=true"
import script from "./backToTop.vue?vue&type=script&lang=js"
export * from "./backToTop.vue?vue&type=script&lang=js"
import style0 from "./backToTop.vue?vue&type=style&index=0&id=aede5abe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede5abe",
  null
  
)

export default component.exports